import { Link } from 'react-router-dom';

export default function TrustSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <p className="font-heading text-xl md:text-2xl text-foreground-400 italic">
            ( Trusted by Spreadsheet Users )
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="px-3 py-1.5 rounded-full bg-foreground-950 text-white text-sm font-semibold flex items-center gap-2 whitespace-nowrap">
              <i className="ri-star-fill text-yellow-400 text-xs"></i>
              5.0 Rating
            </div>
          </div>

          <blockquote className="font-heading text-lg md:text-xl lg:text-2xl text-foreground-800 leading-relaxed italic">
            &ldquo;The mulebuy spreadsheet has completely changed how I source products. Finding trusted agents used to take hours — now I can compare everything in minutes. The spreadsheet data is accurate, regularly updated, and has saved me from several bad deals already.&rdquo;
          </blockquote>

          <div className="flex items-center gap-3 mt-6">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200 flex items-center justify-center">
              <span className="font-heading text-foreground-700 text-lg font-bold">M</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">Marcus R.</p>
              <p className="text-xs text-foreground-500 whitespace-nowrap">Verified Spreadsheet User</p>
            </div>
          </div>

          <div className="flex items-center gap-3 mt-8 pt-6 border-t border-background-100">
            <Link
              to="/"
              className="w-10 h-10 md:w-11 md:h-11 rounded-lg border border-foreground-300 flex items-center justify-center cursor-pointer hover:bg-background-50 transition-colors"
            >
              <i className="ri-arrow-left-line text-foreground-700"></i>
            </Link>
            <Link
              to="/what-is-mulebuy-spreadsheet"
              className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-foreground-950 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-colors"
            >
              <i className="ri-arrow-right-line text-white"></i>
            </Link>
            <span className="text-xs text-foreground-500 ml-2 whitespace-nowrap">
              Read the complete guide
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}